import { Injectable } from '@angular/core';
import { LoaderService, deleteCookie } from '@poste-click-connect/shared-ui';
import { FacadeService } from './facade.service';
import { Router } from '@angular/router';
import { IModalError } from '../interfaces/modal-error';
import { setModalError } from '../utils/error-modal.utils';
import { ErrorCodes } from '../enums/error-codes.enum';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService {
  public isLottomatica: boolean = false;
  public showModalError: boolean = false;
  public isApiError: boolean = false;
  public errorModal: IModalError | null = null;
  public _isLoginCambioPassword: boolean = false;

  get isLoginCambioPassword(): boolean{
    return this._isLoginCambioPassword;
  }

  set isLoginCambioPassword(value: boolean){
    this._isLoginCambioPassword = value;
  }

  constructor(
    private loader: LoaderService,
    private facade: FacadeService,
    private router: Router
  ) {}

  start(): void {
    this.loader.show();
  }

  end(): void {
    this.loader.hide();
  }

  logout(): void {
    if (!this.isLottomatica) {
      this.errorModal = setModalError(ErrorCodes.AUTHORIZATION_DENIED);
      this.showModalError = true;

      return;
    }

    this.effectiveLogout();
  }

  effectiveLogout(): void {
    this.showModalError = false;

    deleteCookie('accessToken', window.location.hostname);
    this.facade.logout();
    this.facade.resetMessages();
    this.router.navigateByUrl('/login');
  }

  closeModalError(): void {
    this.showModalError = false;
    this.isApiError = false;
    this.facade.resetMessages();
  }

  subscriberErrorMessage(): void {
    this.facade.messages.selectMessages$.subscribe((error) => {
      if (error) {
        this.isApiError = true;
        this.errorModal = setModalError(ErrorCodes.SERVICE_NOT_AVAILABLE);
        this.showModalError = true;
      }
    });
  }
}
